import { Link } from 'react-router-dom';
import { FiHome, FiAlertTriangle } from 'react-icons/fi';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content card animate-scale-in">
        <FiAlertTriangle className="warning-icon" />
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page Not Found</h2>
        <p className="error-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary">
          <FiHome /> Back to Home
        </Link>
      </div>

      <style>{`
        .not-found-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: var(--spacing-lg);
        }
        .not-found-content {
          text-align: center;
          padding: var(--spacing-2xl);
          max-width: 500px;
        }
        .warning-icon {
          width: 80px;
          height: 80px;
          color: var(--neon-yellow);
          margin-bottom: var(--spacing-lg);
        }
        .error-code {
          font-size: 6rem;
          font-weight: 800;
          background: var(--gradient-primary);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          line-height: 1;
          margin-bottom: var(--spacing-md);
        }
        .error-title {
          font-size: 1.5rem;
          margin-bottom: var(--spacing-md);
        }
        .error-message {
          color: var(--text-secondary);
          margin-bottom: var(--spacing-xl);
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;
